/* ============
 * Public Holidays Transformer
 * ============
 *
 * The transformer for the public holidays list.
 */

import Transformer from '../transformer';

export default class PublicHolidays extends Transformer {
  static fetch(holiday) {
    return {
      date: holiday.day,
    };
  }
}
